/**
 * Announcement bar (task C3).
 *
 * Rotation never changes layout — all messages are stacked in one grid cell
 * and only opacity animates, so the bar cannot contribute CLS.
 *
 * Dismissal persists in sessionStorage (not localStorage): a promo should come
 * back on the shopper's next visit, not be hidden forever. The storage key
 * includes the message count so editing the bar re-shows it to people who had
 * dismissed the previous version.
 */
(function () {
  'use strict';

  var V = window.Velocity;
  if (!V) return;

  class AnnouncementBar extends V.Element {
    init() {
      this.messages = Array.prototype.slice.call(this.querySelectorAll('[data-message]'));
      this.announcer = this.querySelector('[data-announcer]');
      this.storageKey = this.dataset.storageKey;
      this.index = 0;

      if (this.isDismissed()) {
        this.hidden = true;
        return;
      }

      var closeBtn = this.querySelector('[data-dismiss]');
      if (closeBtn) this.on(closeBtn, 'click', this.dismiss.bind(this));

      this.startRotation();
    }

    destroy() {
      this.stopRotation();
    }

    /* sessionStorage throws in some privacy modes — a promo bar must never
       break the page over it. */
    isDismissed() {
      if (!this.hasAttribute('data-dismissible')) return false;
      try {
        return sessionStorage.getItem(this.storageKey) === '1';
      } catch (e) {
        return false;
      }
    }

    dismiss() {
      this.hidden = true;
      this.stopRotation();
      try {
        sessionStorage.setItem(this.storageKey, '1');
      } catch (e) {
        /* no-op — dismissal simply will not persist */
      }
    }

    startRotation() {
      var interval = parseInt(this.dataset.rotate, 10);
      if (!interval || this.messages.length < 2 || V.prefersReducedMotion()) return;

      this.timer = setInterval(this.next.bind(this), interval);

      // Pause while hovered or focused so a shopper reading a message, or
      // tabbing to its link, does not have it swapped out from under them.
      this.on(this, 'mouseenter', this.stopRotation.bind(this));
      this.on(this, 'focusin', this.stopRotation.bind(this));
      this.on(this, 'mouseleave', this.resume.bind(this));
      this.on(this, 'focusout', this.resume.bind(this));

      // Nothing should animate in a background tab.
      this.on(document, 'visibilitychange', function () {
        if (document.hidden) this.stopRotation();
        else this.resume();
      }.bind(this));
    }

    resume() {
      if (this.timer || this.hidden) return;
      var interval = parseInt(this.dataset.rotate, 10);
      if (interval) this.timer = setInterval(this.next.bind(this), interval);
    }

    stopRotation() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      var previous = this.messages[this.index];
      this.index = (this.index + 1) % this.messages.length;
      var current = this.messages[this.index];

      previous.classList.remove('is-active');
      previous.setAttribute('aria-hidden', 'true');
      current.classList.add('is-active');
      current.removeAttribute('aria-hidden');

      if (this.announcer) this.announcer.textContent = current.textContent.trim();
    }
  }

  V.define('announcement-bar', AnnouncementBar);
})();
